import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32d0ac6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "kt_header",
  style: {},
  class: "header align-items-stretch"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center flex-grow-1 flex-lg-grow-0" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "d-lg-none"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      alt: "Logo",
      src: "/media/logos/7founders-logo.png",
      class: "h-30px"
    })
  ])
], -1))
const _hoisted_3 = { class: "d-flex align-items-stretch justify-content-between flex-lg-grow-1" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex justify-content-between align-items-center",
  id: "kt_header_menu_nav"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Logo",
    src: "/media/logos/7founders-logo.png",
    class: "h-30px"
  })
], -1))
const _hoisted_5 = { class: "d-flex align-items-stretch flex-shrink-0" }
const _hoisted_6 = {
  class: "d-flex align-items-center ms-1 ms-lg-3",
  id: "kt_header_user_menu_toggle"
}
const _hoisted_7 = {
  class: "cursor-pointer symbol symbol-30px symbol-md-40px",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-attach": "parent",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "bottom"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  style: {"margin-left":"0.5rem"},
  class: "primary-text fw-bold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTUserMenu = _resolveComponent("KTUserMenu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([{
        'container-fluid': _ctx.headerWidthFluid,
        'container-xxl': !_ctx.headerWidthFluid,
      }, "d-flex align-items-stretch justify-content-between"])
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("img", {
                src: 
                  _ctx.expertProfileImageUrl
                    ? _ctx.expertProfileImageUrl
                    : _ctx.founderProfileImageUrl
                    ? _ctx.founderProfileImageUrl
                    : '/media/avatars/150-26.jpg'
                ,
                alt: "metronic"
              }, null, 8, _hoisted_8)
            ]),
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.getAuth().currentUser ? _ctx.getAuth().currentUser.displayName : ""), 1),
            _createVNode(_component_KTUserMenu)
          ])
        ])
      ])
    ], 2)
  ]))
}